/**
 * ¿La página se abrió en el navegador interno de Facebook o Instagram?
 * Solo para la metadata de `client_errors` (no cambia la UI).
 *
 * - Instagram primero: su UA dice `Instagram <versión>` y es inequívoco.
 * - Facebook (y Messenger): `FBAN` / `FBAV` / `FB_IAB` (`FBIOS` / `FB4A` son variantes del mismo token).
 *
 * @param {string} [userAgent]
 * @returns {'facebook'|'instagram'|null}
 */
export function detectInAppBrowser(
  userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '',
) {
  const ua = String(userAgent || '');
  if (!ua) return null;
  if (/\bInstagram\b/i.test(ua)) return 'instagram';
  if (/FBAN|FBAV|FB_IAB|FBIOS|FB4A/.test(ua)) return 'facebook';
  return null;
}
